(ns io.repliance.ui.util)

(defn is-descendant-of?
  "Returns `true` if `el` is a descendant of `parent`."
  [el parent]
  (when (and el parent)
    (.contains parent el)))
